import travelKitInitialQuestions, {
  TravelKitQuestionFieldAnswers
} from './initial/questions';

const TravelKitQuestions = [...travelKitInitialQuestions];

export default TravelKitQuestions;

export type { TravelKitQuestionFieldAnswers };
